import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#141329',
        padding: '68px 0px 48px 0px',
        '& > span': {
            fontSize: '48px',
            fontWeight: '800',
            color: '#fff',
            textAlign: 'center',
            marginBottom: '24px',
            maxWidth: 1366,
            [theme.breakpoints.down('md')]: {
                fontSize: '30px',
                lineHeight: '40px',
                padding: '0 24px',
                order: 2,
                marginBottom: 0,
                marginTop: 32
            },
            [theme.breakpoints.down('sm')]: {
                fontSize: '26px',
            },
            [theme.breakpoints.up('md')]: {
                padding: '0 96px',
            }
        },
        [theme.breakpoints.down('md')]: {
            paddingBottom: 12,
            paddingTop: 56
        },
    },
    ctnImage: {
        width: '100%',
        '& img': {
            display: 'block',
            width: '100%',
            height: '100%',
            objectFit: 'contain',
        },
        [theme.breakpoints.down('md')]: {
            order: 1
        }
    },
}));

export default useStyles;